import { CUSTOMER_ROLES } from '@/constants/roles';

export default [
  {
    path: '/postal_codes',
    name: 'postal_codes',
    component: () => import('@/views/pages/postal_codes/PostalCodeList.vue'),
    meta: {
      pageTitle: 'Postal Code List',
      breadcrumb: {
        label: 'Postal Code List'
      },
      roles: CUSTOMER_ROLES
      // verticalMenu: {
      //   title: 'Postal Code List',
      //   icon: 'FileMinusIcon',
      //   parent: 'settingsGroup'
      // }
    }
  },
  {
    path: '/postal_codes/create',
    name: 'create_postal_codes',
    component: () => import('@/views/pages/postal_codes/CreatePostalCode.vue'),
    meta: {
      pageTitle: 'Create Postal Code',
      breadcrumb: {
        label: 'Create Postal Code',
        parent: 'postal_codes'
      },
      roles: CUSTOMER_ROLES
    }
  },
  {
    path: '/postal_codes/:id',
    name: 'edit_postal_codes',
    component: () => import('@/views/pages/postal_codes/EditPostalCode.vue'),
    meta: {
      pageTitle: 'Edit Postal Code',
      breadcrumb: {
        label: 'Edit Postal Code',
        parent: 'postal_codes'
      },
      roles: CUSTOMER_ROLES
    }
  }
];
